import faluda from "./Juice/faluda.png";
import avacado from "./Juice/avacado.png";
import lime from "./Juice/lime.png";
import papaya from "./Juice/papaya.png";
import orange from "./Juice/orange.png";
import watermelon from "./Juice/orange.png";

let juiceItems = [
  {
    item_id: "13",
    item_name: "Special Faluda",
    item_image: faluda,
    item_price: "650",
    item_category: "juice",
  },
  {
    item_id: "14",
    item_name: "Avacado",
    item_image: avacado,
    item_price: "600",
    item_category: "juice",
  },
  {
    item_id: "15",
    item_name: "Lime Juice",
    item_image: lime,
    item_price: "450",
    item_category: "juice",
  },
  {
    item_id: "16",
    item_name: "Papaya Juice",
    item_image: papaya,
    item_price: "550",
    item_category: "juice",
  },
  {
    item_id: "17",
    item_name: "Orange Juice",
    item_image: orange,
    item_price: "600",
    item_category: "juice",
  },
  {
    item_id: "18",
    item_name: "Watermelon",
    item_image: watermelon,
    item_price: "580",
    item_category: "juice",
  },
];
export default juiceItems